import houseSvg from '../../../assets/house.svg';
import whiteHouseSvg from '../../../assets/house-white.svg';

const icons = [houseSvg, houseSvg, whiteHouseSvg, houseSvg, houseSvg];

const HouseIcons = () => {
    return (
        <div className="flex items-center gap-4">
            {icons.map((icon, index) => (
                <img 
                    key={index} 
                    src={icon} 
                    alt={`house-icon-${index}`} 
                    className="w-5 h-5"
                />
            ))}
        </div>
    );
}

export default HouseIcons;